<template>
  <div class="base-search-condition-modal">
    <el-row class="search-box">
      <div class="search-input">
        <el-select
            slot="reference"
            v-model="selectTemplateId"
            :class="'selectAndCreate'"
            :no-match-text="'No matching data'"
            :no-data-text="'No data'">
          <el-option v-for="item in templateOptions"
              :key="item['value']"
              :label="item['name']"
              :value="item['value']">
            <slot :item="item" />
          </el-option>
        </el-select>
      </div>
      <div>
        <el-button :disabled="createDisable"
            @click="submitUpload">
          アップロード
        </el-button>
      </div>
      <div>
        <el-button
            @click="getLatest">
          最新情報取得
        </el-button>
      </div>
    </el-row>

    <el-row class="base-search-condition">
      <div class="search-input">
        <label class="selector-title">
          アップロードファイル
        </label>
        <el-input v-model="fileMsg"
            type="text"
            :readonly="true" />
        <label class="el-button">
          選択
          <input type="file"
              style="display:none"
              @change="onChange"
              @click="onClick">
        </label>
      </div>
    </el-row>
  </div>
</template>

<style scoped>
  .selectAndCreate {
    display: inline-block;
    width: 100%;
  }
  .search-input ::v-deep .el-input {
  width: 100%;
}
</style>

<script>
import { mapState } from 'vuex'

import moment from 'moment'
import common from '@/utils/common'
import * as query from '@/queries/upload'
import * as config from '@/config'
import message from '@/utils/message'

export default {
  name: 'UploadConditionModal',
  props: {
    // localstorage key
    saveKey: {
      type: String,
      required: true
    }
  },
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  data () {
    return {
      dialogVisible: false,
      selectTemplateId: null,
      createDisable: true,
      uploadDisable: true,
      uploadFile: null,
      fileMsg: '選択されていません'
    }
  },
  computed: {
    ...mapState({
      templateInfo: (state) => state.Upload.templateInfo
    }),
    templateOptions () {
      return this.templateInfo.map((template) => { return { value: template.id, name: template.displayValue } })
    }
  },
  async created () {
    this.$loadingService.show()
    try {
      // テンプレート情報取得
      await this.getTemplateData()
    } catch (error) {
      this.$notify.error({ error: error })
      throw error
    } finally {
      this.$loadingService.close()
    }
  },
  methods: {
    // アップロード処理を実行します。
    submitUpload: async function () {
      try {
        if (!this.$validator.validate()) {
          return
        }

        if (!this.uploadFile) {
          this.$notify.error({
            message: 'ファイルが選択されていません。'
          })
          return
        }

        this.$loadingService.show()

        // 選択ファイル
        let uploadData = this.uploadFile

        // ハッシュ + ファイル名
        let uploadName = uploadData.name

        const time = moment().tz('Asia/Tokyo').format('YYYYMMDD_HHmmss')

        const url = new URL(config.GET_S3_SIGNED_URL)
        url.searchParams.set('urlType', 1)
        url.searchParams.set('key1', 'upload')
        url.searchParams.set('key2', 'upload_folder_key')
        url.searchParams.set('key3', 'temp')
        url.searchParams.set('fileKey', time + '_' + uploadName)

        // 署名付きURL取得API呼び出し
        const response = await common.apiAxios(url,
          { method: 'get' })
        const signedURL = response.data.signedUrl

        // アップロード(署名付きURLにPUT)
        const request = new XMLHttpRequest()
        request.open('PUT', signedURL, false)
        request.send(uploadData)
        if (request.status !== 200) {
          throw new Error('アップロードリクエストに失敗しました。')
        }

        // アップロードファイルパス(署名なし)
        let fileKey = new URL(signedURL)
        // pathname: /{HOST}.s3.cc-s.net/backup/import/upload/ time + uploadName
        // 「バックアップフォルダ/ time + uploadName」に加工
        fileKey = fileKey.pathname.split('/').slice(2).join('/')

        // アップロードAPI呼び出し
        const method = 'post'
        await common.apiAxios(config.UPLOAD, {
          method,
          data: { uploadTemplateId: this.selectTemplateId, fileKey: fileKey }
        })
        this.uploadFile = null
        this.fileMsg = '選択されていません'

        // 親の再描画イベントを呼ぶ
        this.$emit('getLatest')
      } catch (error) {
        let errorMsg = ''
        if (error.response && error.response.status === 503) {
          errorMsg = message.MSG_573({ reason: error.response.data.reason })
          common.addError(error, { msg: errorMsg })
        }
        this.$notify.error({ error: error })
        throw error
      } finally {
        this.$loadingService.close()
      }
    },
    onChange (e) {
      // 選択されたファイルを保存
      const files = e.target.files
      if (files.length < 1) {
        return
      }
      this.uploadFile = files[0]

      this.fileMsg = this.uploadFile.name
    },
    onClick (e) {
      e.target.value = ''
    },
    getLatest: async function () {
      // 親の再描画イベントを呼ぶ
      this.$emit('getLatest')
    },
    async getTemplateData () {
      if (!this.templateInfo || !this.templateInfo.length > 0) {
        const res = await common.postGraphQl(query.GRAPH_QL_QUERY_UPLOAD_TEMPLATE)
        const allOptions = common.getValueByPath(res.data, 'data.uploadTemplate')
        this.$store.dispatch({
          type: 'set',
          states: {
            'Upload/templateInfo': allOptions.filter((option) => {
              return !this.$isFunctionDisabled(option.permissionConfigRefKey)
            })
          }
        })
      }
      // 一つ目のテンプレートを自動選択する
      if (this.templateInfo && this.templateInfo.length > 0) {
        this.selectTemplateId = this.templateInfo[0].id
        this.createDisable = false
      } else {
        this.createDisable = true
      }
    }
  }
}
</script>
